import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "../models/DefaultResponse";
import { Observable, map } from "rxjs";
import { PlanoCadastro } from "../models/plano/plano";

@Injectable({
  providedIn: 'root'
})
export class PlanoService {

  private api = ConvivaApi;

  constructor(
    private http: HttpClient,
    private router:Router)
  { }

  public getAllPlanos():Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.Plano.GetAllPlanos}`)
                    .pipe(map((response: DefaultResponse) => response));
  }

  public cadastrarPlano(plano: PlanoCadastro): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.Plano.SetCadastrarPlano}`, plano)
                    .pipe(map((response: DefaultResponse) => response));
  }
}
